import React, { useEffect, Fragment } from "react";
import {
    MuiPickersUtilsProvider,
    KeyboardDateTimePicker
} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { TextField, FormHelperText } from '@material-ui/core';
import SvgIcon from '@material-ui/core/SvgIcon';
import Button from "@material-ui/core/Button";
import { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import submitData from '../submitData';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useForm, Controller } from "react-hook-form";
import InputMask from 'react-input-mask';
import { differenceInMonths } from 'date-fns';
import { useHistory } from "react-router-dom";

interface Observation {
    index: number | null,
    dateAndTimeObject: Date | null,
    dateAndTime: string | null,
    pulse: number | null,
    capRefill: number | null,
    respRate: number | null,
    sP02: number | null,
    pain: number | null,
    avpu: string | null,
    temp: number | null,
    bpSystolic: number | null,
    bpDiastolic: number | null,
    bgl: number | null,
    error: boolean | null,
    errorStr: string | null
};

interface ValidationRule {
    pulse: {
        min: number,
        max: number
    },
    capRefill: {
        max: number
    },
    respRate: {
        min: number,
        max: number
    },
    spO2: {
        max: number
    },
    pain: {
        max: number
    },
    avpu: {
        value: string
    },
    temp: {
        max: number,
        min: number
    },
    bp: {
        min: number,
        max: number
    },
    bgl: {
        min: number,
        max: number
    }
}

interface AgeDetails {
    years: number,
    months: number
};

const useStyles = makeStyles((theme) => ({
    formControlLabel: {
        fontSize: 13,
        color: '#4A4A4A',
        fontWeight: 'bold',
        padding: theme.spacing(0, 0, 1, 0)

    },
    formControlLabelSub: {
        fontSize: 13,
        color: '#333333',
        padding: theme.spacing(0, 0, 1, 0)

    },
    helpText: {
        color: 'red',
        padding: theme.spacing(0, 0, 0, 2)
    },
    textFieldRoot: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: '#F4B827'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#F4B827'
            },
            '&.Mui-error fieldset': {
                borderColor: '#F4B827'
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderColor: '#F4B827'
    },
    textFieldInput: {
        backgroundColor: '#FCEBC2',
        color: '#000000',
        borderColor: '#F4B827',
    },
    resize: {
        fontSize: 16,
        textAlign: 'center'
    },
    dateTimePicker: {
        "& h3":
        {
            fontSize: '3rem'
        },
        "& h4":
        {
            fontSize: '2rem'
        },
        "& button":
        {
            minWidth: 0
        },


    }
}));

const WarningIcon = () => {
    return (
        <SvgIcon key="WarningIcon" width="44" height="44" viewBox="0 0 44 44">
            <defs>
                <clipPath id="clip-path-one">
                    <path id="Combined_Shape-One" data-name="Combined Shape" d="M12.576,40.333a1.843,1.843,0,0,1-1.3-.536L.536,29.053A1.844,1.844,0,0,1,0,27.756V12.576a1.843,1.843,0,0,1,.536-1.3L11.281.536A1.843,1.843,0,0,1,12.576,0h15.18a1.844,1.844,0,0,1,1.3.536L39.8,11.281a1.843,1.843,0,0,1,.536,1.3v15.18a1.844,1.844,0,0,1-.536,1.3L29.053,39.8a1.844,1.844,0,0,1-1.3.536Zm-8.91-27V27l9.669,9.669H27L36.666,27V13.335L27,3.666H13.335Zm15.2,13.627a1.832,1.832,0,1,1,1.3.537A1.832,1.832,0,0,1,18.871,26.963Zm-.538-6.8V12.834a1.833,1.833,0,1,1,3.666,0v7.333a1.833,1.833,0,0,1-3.666,0Z" transform="translate(0 0)" />
                </clipPath>
            </defs>
            <g id="alert-octagon" opacity="0.619">
                <g id="Group_3" data-name="Group 3" transform="translate(1.833 1.833)">
                    <path id="Combined_Shape-2" data-name="Combined Shape 2" d="M12.576,40.333a1.843,1.843,0,0,1-1.3-.536L.536,29.053A1.844,1.844,0,0,1,0,27.756V12.576a1.843,1.843,0,0,1,.536-1.3L11.281.536A1.843,1.843,0,0,1,12.576,0h15.18a1.844,1.844,0,0,1,1.3.536L39.8,11.281a1.843,1.843,0,0,1,.536,1.3v15.18a1.844,1.844,0,0,1-.536,1.3L29.053,39.8a1.844,1.844,0,0,1-1.3.536Zm-8.91-27V27l9.669,9.669H27L36.666,27V13.335L27,3.666H13.335Zm15.2,13.627a1.832,1.832,0,1,1,1.3.537A1.832,1.832,0,0,1,18.871,26.963Zm-.538-6.8V12.834a1.833,1.833,0,1,1,3.666,0v7.333a1.833,1.833,0,0,1-3.666,0Z" transform="translate(0 0)" />
                    <g id="Mask_Group_3" data-name="Mask Group 3" clip-path="url(#clip-path-one)">
                        <g id="COLOR_black" data-name="COLOR/ black" transform="translate(-1.833 -1.833)">
                            <rect id="Rectangle" width="44" height="44" />
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
}

const AddIcon = () => {
    return (
        <SvgIcon key="AddIcon" style={{ height: 24, width: 24 }}>
            <defs>
                <clipPath id="clip-path">
                    <path id="Combined_Shape" data-name="Combined Shape" d="M3.222,18.778A11,11,0,1,1,18.778,3.222,11,11,0,1,1,3.222,18.778ZM2,11a9,9,0,1,0,9-9A9.01,9.01,0,0,0,2,11Zm8,4V12H7a1,1,0,1,1,0-2h3V7a1,1,0,1,1,2,0v3h3a1,1,0,0,1,0,2H12v3a1,1,0,0,1-2,0Z" transform="translate(0 0)" />
                </clipPath>
            </defs>
            <g id="Group_17" data-name="Group 17">
                <path id="Combined_Shape-2" data-name="Combined Shape" d="M3.222,18.778A11,11,0,1,1,18.778,3.222,11,11,0,1,1,3.222,18.778ZM2,11a9,9,0,1,0,9-9A9.01,9.01,0,0,0,2,11Zm8,4V12H7a1,1,0,1,1,0-2h3V7a1,1,0,1,1,2,0v3h3a1,1,0,0,1,0,2H12v3a1,1,0,0,1-2,0Z" transform="translate(0 0)" />
                <g id="Mask_Group_17" data-name="Mask Group 17" clip-path="url(#clip-path)">
                    <g id="COLOR_black" data-name="COLOR/ black">
                        <rect id="Rectangle" width="24" height="24" fill="#02489d" />
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
}

const HorizontalLine = () => {
    return (
        <hr
            style={{
                border: 0,
                borderTop: '1px solid #DADADA',
            }}
        />
    )
}

const getAge = (dateString: string) => {
    let months = differenceInMonths(new Date(), new Date(dateString));
    let data: AgeDetails = { years: 0, months: 0 };
    if (months >= 12) {
        data.years = ((months - (months % 12)) / 12);
    } else {
        data.months = months;
    }
    return data;
}

const getValidationParams = (age: AgeDetails) => {
    let validationParams: ValidationRule = {
        pulse: {
            min: 100,
            max: 170
        },
        capRefill: {
            max: 3
        },
        respRate: {
            min: 25,
            max: 65
        },
        spO2: {
            max: 95
        },
        pain: {
            max: 4
        },
        avpu: {
            value: 'A'
        },
        temp: {
            min: 35.5,
            max: 38.5
        },
        bp: {
            min: 60,
            max: 100
        },
        bgl: {
            min: 4,
            max: 20
        }
    }

    if (age.years >= 18) {
        validationParams.pulse.min = 50;
        validationParams.pulse.max = 120;
        validationParams.respRate.min = 10;
        validationParams.respRate.max = 25;
        validationParams.pain.max = 7;
        validationParams.bp.min = 100;
        validationParams.bp.max = 180;
        return validationParams;
    }

    if (age.years >= 12) {
        validationParams.pulse.min = 50;
        validationParams.pulse.max = 130;
        validationParams.respRate.min = 10;
        validationParams.respRate.max = 30;
        validationParams.pain.max = 4;
        validationParams.bp.min = 90;
        validationParams.bp.max = 160;
        return validationParams;
    }

    if (age.years >= 5) {
        validationParams.pulse.min = 70;
        validationParams.pulse.max = 140;
        validationParams.respRate.min = 15;
        validationParams.respRate.max = 35;
        validationParams.pain.max = 4;
        validationParams.bp.min = 90;
        validationParams.bp.max = 130;
        return validationParams;
    }

    if (age.years >= 1) {
        validationParams.pulse.min = 80;
        validationParams.pulse.max = 150;
        validationParams.respRate.min = 20;
        validationParams.respRate.max = 50;
        validationParams.pain.max = 4;
        validationParams.bp.min = 80;
        validationParams.bp.max = 120;
        return validationParams;
    }

    if (age.months >= 3 && age.years == 0) {
        validationParams.pulse.min = 90;
        validationParams.pulse.max = 170;
        validationParams.respRate.min = 25;
        validationParams.respRate.max = 55;
        validationParams.pain.max = 4;
        validationParams.bp.min = 70;
        validationParams.bp.max = 110;
        return validationParams;
    }

    if (age.months >= 0 && age.years == 0) {
        validationParams.pulse.min = 100;
        validationParams.pulse.max = 170;
        validationParams.respRate.min = 25;
        validationParams.respRate.max = 65;
        validationParams.pain.max = 4;
        validationParams.bp.min = 60;
        validationParams.bp.max = 100;
        return validationParams;
    }
    return validationParams;
}

const Observations = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch }: any) => {
    const classes = useStyles();
    const { errors, setError, clearErrors } = useForm();
    const observation: Observation = {
        index: 0,
        dateAndTimeObject: null,
        dateAndTime: null,
        pulse: null,
        capRefill: null,
        respRate: null,
        sP02: null,
        pain: null,
        avpu: null,
        temp: null,
        bpSystolic: null,
        bpDiastolic: null,
        bgl: null,
        error: false,
        errorStr: ''
    }
    const [observations, setObservations] = useState([observation]);
    const [observationsCount, setObservationsCount] = useState(1);
    const [alertCalling, setAlertCalling] = useState(false);
    const [advancedCalling, setAdvancedCalling] = useState(false);
    const [validObs, setValidObs] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (data && data.observations) {
            let dateUtil = new DateFnsUtils();
            setAlertCalling(data.alteredCallingCriteria ?? false);
            setAdvancedCalling(data.advancedCareDirective ?? false);
            let observationsArray: Observation[] = [...data.observations];
            if (observationsArray.length > 0) {
                observationsArray.forEach((item, index: number) => {
                    if (item.dateAndTime)
                        item.dateAndTimeObject = dateUtil.parse(item.dateAndTime, "yyyy-MM-dd'T'HH:mm:ss");
                    else
                        item.dateAndTimeObject = null;

                });
                observationsArray = observationsArray.sort(function compare(a, b) {
                    let dateA: any = a.dateAndTimeObject;
                    let dateB: any = b.dateAndTimeObject;
                    return dateB - dateA;
                });

                observationsArray.forEach((item, index: number) => {
                    item.index = index;

                });

                setObservations(observationsArray);
                setObservationsCount(observationsArray.length);
                validateObservations(observationsArray);
            }
        }
    }, [data]);

    const saveChanges = async (update = false) => {
        if (await getDataLocal()) {
            let newData = { "observations": observations.filter(o => o.dateAndTimeObject), "alteredCallingCriteria": alertCalling, "advancedCareDirective": advancedCalling, "observationsStatus": validObs };
            handleData(newData);
            if (update == true) submitData({ ...data, ...newData }, dispatch, history);
        }
    }

    React.useEffect(() => {
        saveChangesState[1](() => saveChanges);
    }, [observations, data])



    const validateSingleObservation = (ob: Observation, rules: ValidationRule, age: AgeDetails, fieldName: string, obs: Observation[]): boolean => {
        let IsValid = true;
        let HasValue = true;
        if (fieldName === 'pulse') {
            HasValue = ob.pulse ? true : false;
            if (ob.pulse && !(ob.pulse >= rules.pulse.min && ob.pulse <= rules.pulse.max))
                IsValid = false;
        }
        if (fieldName === 'capRefill') {
            HasValue = ob.capRefill ? true : false;
            if (ob.capRefill && !(ob.capRefill < rules.capRefill.max))
                IsValid = false;
        }
        if (fieldName === 'respRate') {
            HasValue = ob.respRate ? true : false;
            if (ob.respRate && !(ob.respRate >= rules.respRate.min && ob.respRate <= rules.respRate.max))
                IsValid = false;
        }
        if (fieldName === 'sP02') {
            HasValue = ob.sP02 ? true : false;
            if (ob.sP02 && !(ob.sP02 >= rules.spO2.max))
                IsValid = false;
        }
        if (fieldName === 'pain') {
            HasValue = ob.pain ? true : false;
            if (ob.pain && !(ob.pain < rules.pain.max))
                IsValid = false;
        }
        if (fieldName === 'avpu') {
            HasValue = ob.avpu ? true : false;
            if (ob.avpu && !(ob.avpu == rules.avpu.value))
                IsValid = false;
        }
        if (fieldName === 'temp') {
            HasValue = ob.temp ? true : false;
            if (ob.temp && !(ob.temp >= rules.temp.min && ob.temp < rules.temp.max))
                IsValid = false;
        }
        if (fieldName === 'bpSystolic') {
            HasValue = ob.bpSystolic ? true : false;
            if (ob.bpSystolic && !(ob.bpSystolic >= rules.bp.min && ob.bpSystolic < rules.bp.max))
                IsValid = false;
        }
        if (fieldName === 'bgl') {
            HasValue = ob.bgl ? true : false;
            if (ob.bgl && !(ob.bgl >= rules.bgl.min && ob.bgl <= rules.bgl.max))
                IsValid = false;
        }
        if (!IsValid) {
            setError(fieldName + ob.index, { message: "", type: "validate" });
        } else {
            clearErrors(fieldName + ob.index);
        }

        if (IsValid && !HasValue) {
            obs.every((item: any, index) => {
                let HasNextValue = item[fieldName] ? true : false;
                if (HasNextValue) {
                    IsValid = validateSingleObservation(item, rules, age, fieldName, obs);
                    return false;
                }
                return true;
            });
        }
        return IsValid;
    }

    const validateAndSkip = (obs: Observation[], rules: ValidationRule, age: AgeDetails): boolean => {
        let validateStates = {
            pulse: false,
            capRefill: false,
            respRate: false,
            spO2: false,
            pain: false,
            avpu: false,
            temp: false,
            bp: false,
            bgl: false
        };

        obs.forEach((ob: Observation) => {
            if (!validateStates.pulse && !validateStates.capRefill && !validateStates.respRate && !validateStates.spO2 && !validateStates.pain &&
                !validateStates.avpu && !validateStates.temp && !validateStates.bp && !validateStates.bgl) {
                if (!validateStates.pulse)
                    validateStates.pulse = validateSingleObservation(ob, rules, age, 'pulse', obs);
                if (!validateStates.capRefill)
                    validateStates.capRefill = validateSingleObservation(ob, rules, age, 'capRefill', obs);
                if (!validateStates.respRate)
                    validateStates.respRate = validateSingleObservation(ob, rules, age, 'respRate', obs);
                if (!validateStates.spO2)
                    validateStates.spO2 = validateSingleObservation(ob, rules, age, 'sP02', obs);
                if (!validateStates.pain)
                    validateStates.pain = validateSingleObservation(ob, rules, age, 'pain', obs);
                if (!validateStates.avpu)
                    validateStates.avpu = validateSingleObservation(ob, rules, age, 'avpu', obs);
                if (!validateStates.temp)
                    validateStates.temp = validateSingleObservation(ob, rules, age, 'temp', obs);
                if (!validateStates.bp)
                    validateStates.bp = validateSingleObservation(ob, rules, age, 'bpSystolic', obs);
                if (!validateStates.bgl)
                    validateStates.bgl = validateSingleObservation(ob, rules, age, 'bgl', obs);
            }
        });

        if (!validateStates.pulse || !validateStates.capRefill || !validateStates.respRate || !validateStates.spO2 || !validateStates.pain ||
            !validateStates.avpu || !validateStates.temp || !validateStates.bp || !validateStates.bgl) {
            setValidObs(true);
            return true;
        }
        else {
            setValidObs(false);
            return false;
        }
    }

    const validateObservations = async (observations: any[]) => {
        setValidObs(false);
        await clearErrors();
        let sortedObs = observations.sort(function compare(a, b) {
            let dateA: any = a.dateAndTimeObject;
            let dateB: any = b.dateAndTimeObject;
            return dateB - dateA;
        });

        let age = getAge(data.birthday);
        let rules = getValidationParams(age);
        return validateAndSkip(sortedObs, rules, age);
    }

    const getDataLocal = async () => {
        for (let item = 0; item < observationsCount; item++) {
            let observation = observations[item];


            if ((observation.pulse || observation.capRefill || observation.respRate
                || observation.sP02 || observation.pain || observation.avpu
                || observation.temp || observation.bpSystolic || observation.bgl) && (!observation.dateAndTime)) {
                textChange(true, item, 'error', 'Date and Time field is required');
                return false;
            }

            if ((observation.dateAndTime) && (!observation.pulse && !observation.capRefill && !observation.respRate
                && !observation.sP02 && !observation.pain && !observation.avpu
                && !observation.temp && !observation.bpSystolic && !observation.bgl)) {
                textChange(true, item, 'error', 'One of the other field is required');
                return false;
            }
        }
        return true;
    }



    const handleNext = async () => {
        if (await getDataLocal()) {
            let newData = { "observations": observations.filter(o => o.dateAndTimeObject), "alteredCallingCriteria": alertCalling, "advancedCareDirective": advancedCalling, "observationsStatus": validObs };
            handleData(newData);
            return true;
        }
        return false;
    }

    const deleteObservation = (index: number) => {
        let observationTemp = [...observations];
        if (index > -1) {
            observationTemp.splice(index, 1);
        }
        setObservations([...observationTemp]);
        setObservationsCount((count) => count - 1);
    }

    const appendObservation = (newObservation: any) => {
        setObservations(observations.concat(newObservation));
    }

    const addObservation = () => {
        setObservationsCount(observationsCount + 1);
        let tempObservation = observation;
        tempObservation.index = observationsCount;
        appendObservation(tempObservation);
    }

    const textChange = (value: any, index: number, field: string, errorStr?: string) => {
        let dateUtil = new DateFnsUtils();
        let items = [...observations];
        let item = { ...items[index] };
        let checkNum = Number(value) <= 0;
        let checkPainNum =  Number(value) <=10 && Number(value) >=0;
        let checkPainNumzero =  Number(value) <0 ;
        let checkAlp = ['A', 'V', 'P', 'U', 'a', 'v', 'p', 'u', ''].includes(value);

        switch (field) {
            case 'dateAndTimeObject':
                item.dateAndTime = value && !isNaN(value.getTime()) ? dateUtil.format(value, "yyyy-MM-dd'T'HH:mm:ss") : null;
                item.dateAndTimeObject = value;
                break;
            case 'pulse':
                item.pulse = checkNum ? '' : value;
                break;
            case 'capRefill':
                item.capRefill = checkNum ? '' : value;
                break;
            case 'respRate':
                item.respRate = checkNum ? '' : value;
                break;
            case 'sP02':
                item.sP02 = checkNum ? '' : value;
                break;
            case 'pain':
                if (value=="")
                item.pain =null;
                else if (value.trim=="")
                item.pain =null;
                else
                item.pain = checkPainNum ? value : null;
              break;
            case 'avpu':
                item.avpu = checkAlp ? value.toUpperCase() : '';
                break;
            case 'temp':
                item.temp = checkNum ? '' : value;
                break;
            case 'bgl':
                item.bgl = checkNum ? '' : value;
                break;
            case 'bpSystolic':
                item.bpSystolic = value.split('/')[0] ?? null;
                item.bpDiastolic = value.split('/')[1] ?? null;
                break;
            case 'error':
                item.error = value;
                item.errorStr = errorStr ? errorStr : "";
                break;
            default:
                break;
        }

        if (field !== 'error')
            item.error = false;

        items[index] = item;
        setObservations([...items]);

        if (field !== 'dateAndTime' && field !== 'error')
            validateObservations(items);
    }

    const ValidationTextField = (filedName: string, index: number, value: any | null, space?: boolean | undefined) => {
        return (
            <TextField value={value}
                key={'txt' + filedName + index}
                variant='outlined'
                type={filedName !== 'avpu' ? 'number' : ''}
                style={!space ? { marginTop: 3 } : {}}
                onChange={(e: any) => {
                    if (filedName=='pain')
                    {
                        if (e.target.value > 10)
                            e.target.value=10;
                        else if (e.target.value < 0)
                            e.target.value=0;
                    }
                    textChange(e.target.value, index, filedName)
                }}
                error={errors[filedName + index]}
                classes={errors[filedName + index] ? { root: classes.textFieldRoot } : {}}
                inputProps={filedName !== 'pain' ? { maxLength: 3 }:{min: 0, max: 10, maxLength: 2}}
                InputProps={errors[filedName + index] ?
                    { classes: { root: classes.textFieldInput, input: classes.resize } } :
                    { classes: { input: classes.resize } }}
                helperText={errors[filedName + index] ? errors[filedName + index].message : ""} />
        );
    }

    const MaskTextField = (filedName: string, index: number, value: any, space?: boolean | undefined) => {
        return (
            <InputMask
                mask="999/999"
                value={value}
                disabled={false}
                onChange={(e: any) => textChange(e.target.value, index, filedName)}
                maskChar=" ">
                {() =>
                    <TextField
                        key={'txt' + filedName + index}
                        variant='outlined'
                        style={!space ? { marginTop: 3 } : {}}
                        error={errors[filedName + index]}
                        classes={errors[filedName + index] ? { root: classes.textFieldRoot } : {}}
                        InputProps={errors[filedName + index] ? {
                            classes: { root: classes.textFieldInput, input: classes.resize }
                        } : { classes: { input: classes.resize } }}
                        helperText={errors[filedName + index] ? errors[filedName + index].message : ""}
                    />
                }
            </InputMask>
        );
    }

    return (
        <React.Fragment >
            <Grid>
                <Grid style={{paddingTop:40}} container spacing={3} alignItems="flex-start">
                    <Grid item xs={6} >
                        <Typography style={{ fontSize: 36, fontWeight: 900, }}>
                            Observations</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        {!isEdit && <NextButton onClick={handleNext} />}
                        <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
                        <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
                    </Grid>
                </Grid>

                {
                    validObs && !(alertCalling || advancedCalling) ?
                        <Grid container style={{ backgroundColor: '#FAE1A5', borderRadius: 5, marginTop: 20, marginBottom: 20, }} alignItems="flex-start">
                            <Grid style={{ marginTop: 20, marginLeft: 20 }} item>
                                <WarningIcon />
                            </Grid>
                            <Grid item xs={11}>
                                <div style={{ marginLeft: 10, fontSize: 18, wordBreak: 'break-word' }}>
                                    <p style={{ fontWeight: 'bold', wordBreak: 'break-word' }}>
                                        One or more of the most recent clinical observations are outside the flags. You have not indicated there is an Altered Calling Criteria or Advanced Care Directive in place for this patient.
                                    </p>
                                    <p>
                                        To avoid adverse outcomes and/or delays, please confirm an Altered Care Criteria or Advanced Care Directive is in place or initiate clinical review.
                                    </p>
                                </div>
                            </Grid>
                        </Grid>
                        :
                        null
                }


                <Grid container spacing={3} alignItems="flex-start">
                    <Grid item xs={6} style={{ marginTop: 5, marginBottom: 5 }}>
                        <FormControlLabel style={{ wordBreak: 'break-word', }}
                            control={<Checkbox checked={alertCalling} onChange={() => { setAlertCalling(!alertCalling) }} />}
                            label=
                        {
                                "This patient has an Altered Calling Criteria\n(between the flags response criteria has been altered for this patient)"
                            }
                        />
                        
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: 5, marginBottom: 5 }}>
                        <FormControlLabel style={{ wordBreak: 'break-word', }}
                            control={<Checkbox checked={advancedCalling} onChange={() => { setAdvancedCalling(!advancedCalling) }} />}
                            label="This patient has an Advanced Care Directive"
                        />
                    </Grid>
                </Grid>


                <Grid container spacing={3} alignItems="flex-start">
                    <Grid item xs={6} style={{ marginBottom: 20 }}>
                        {
                            alertCalling ?
                                <div style={{ padding: 5, paddingTop: 15, backgroundColor: '#FAE1A5', borderRadius: 5, fontSize: 13, wordBreak: 'normal' }}>
                                    <b style={{marginLeft: 24}}>Please ensure:</b>
                                            <ul style={{ marginTop: 0, }}>
                                        <li>A copy accompanies the patient at all times</li>
                                        <li>The Altered Calling Criteria is both current and valid</li>
                                        <li>The Altered Calling Criteria addresses all clinical observations outside the flags</li>
                                    </ul>
                                </div>
                                : null
                        }
                    </Grid>
                    <Grid item xs={6} style={{ marginBottom: 20 }}>
                        {
                            advancedCalling ?
                                <div style={{ padding: 5, paddingTop: 15, backgroundColor: '#FAE1A5', borderRadius: 5, fontSize: 13, wordBreak: 'normal' }}>
                                    <b style={{ marginLeft: 24 }}>Please ensure:</b>
                                            <ul style={{ marginTop: 0, }}>
                                        <li>A copy accompanies the patient at all times</li>
                                        <li>The Advanced Care Directive is both current and valid</li>
                                        <li>The Advanced Care Directive addresses all clinical observations outside the flags</li>
                                    </ul>
                                </div>
                                : null
                        }
                    </Grid>
                </Grid>

                <Grid item xs={12} style={{ marginTop: 5, marginBottom: 20 }}>
                    <HorizontalLine />
                </Grid>

                <div>
                    {observations.map((observation, index) => {
                        return (
                            <Grid key={'observation' + index} container spacing={1} alignItems="flex-start" style={{ paddingTop: 20, borderBottom: "1px solid" }}>
                                <Grid container item spacing={1} xs={11} alignItems="flex-start">
                                    <Grid item lg={2} xl={2}>
                                        <div className={classes.formControlLabel}>DATE TIME</div>
                                        <div className={classes.formControlLabelSub}>dd/mm/yy HH:mm</div>
                                        <Fragment>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDateTimePicker
                                                    InputProps={{
                                                        style: { fontSize: 16 }
                                                    }}
                                                    disableFuture={true}
                                                    format="dd/MM/yyyy HH:mm"
                                                    placeholder="dd/mm/yyyy HH:mm"
                                                    ampm={false}
                                                    key={'dateAndTime' + index}
                                                    inputVariant='outlined'
                                                    initialFocusedDate={null}
                                                    style={{

                                                        marginTop: 3
                                                    }}
                                                    invalidDateMessage='Invalid'
                                                    value={observation.dateAndTimeObject}
                                                    onChange={(date, value) => { textChange(date, index, 'dateAndTimeObject') }}
                                                    DialogProps={{
                                                        className: classes.dateTimePicker
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Fragment>
                                    </Grid>
                                    <Grid item lg={1} >
                                        <div className={classes.formControlLabel}>PULSE</div>
                                        <div className={classes.formControlLabelSub}>Bpm</div>
                                        {ValidationTextField('pulse', index, observation.pulse)}
                                    </Grid>
                                    <Grid item xl={1} lg={2}>
                                        <div className={classes.formControlLabel}>CAP REFILL(S)</div>
                                        <div className={classes.formControlLabelSub}>Seconds</div>
                                        {ValidationTextField('capRefill', index, observation.capRefill)}
                                    </Grid>
                                    <Grid item xl={1} lg={2}>
                                        <div className={classes.formControlLabel}>RESP/MIN</div>
                                        <div className={classes.formControlLabelSub}>Breaths/Min</div>
                                        {ValidationTextField('respRate', index, observation.respRate)}
                                    </Grid>
                                    <Grid item lg={1}>
                                        <div className={classes.formControlLabel}>SPO<sup>2</sup></div>
                                        <div className={classes.formControlLabelSub}>%</div>
                                        {ValidationTextField('sP02', index, observation.sP02, true)}
                                    </Grid>
                                    <Grid item lg={1}>
                                        <div className={classes.formControlLabel}>PAIN/10</div>
                                        <div className={classes.formControlLabelSub}>Out of 10</div>
                                        {ValidationTextField('pain', index, observation.pain)}
                                    </Grid>
                                    <Grid item lg={1}>
                                        <div className={classes.formControlLabel}>AVPU</div>
                                        <div className={classes.formControlLabelSub}>A,V,P or U</div>
                                        {ValidationTextField('avpu', index, observation.avpu)}
                                    </Grid>
                                    <Grid item lg={1}>
                                        <div className={classes.formControlLabel}>TEMP</div>
                                        <div className={classes.formControlLabelSub}><sup>o</sup>C</div>
                                        {ValidationTextField('temp', index, observation.temp, true)}
                                    </Grid>
                                    <Grid item xl={1} lg={2}>
                                        <div className={classes.formControlLabel}>BP</div>
                                        <div className={classes.formControlLabelSub}>Sys/Dia(mmhg)</div>
                                        {MaskTextField('bpSystolic', index, observation.bpSystolic?.toString().padStart(3, ' ') + '/' + observation.bpDiastolic?.toString().padStart(3, ' '))}
                                    </Grid>
                                    <Grid item lg={1}>
                                        <div className={classes.formControlLabel}>BGL</div>
                                        <div className={classes.formControlLabelSub}>mmol/L</div>
                                        {ValidationTextField('bgl', index, observation.bgl)}
                                    </Grid>
                                </Grid>
                                {
                                    <Grid item>
                                        {
                                            index != 0 ?
                                                <IconButton onClick={() => deleteObservation(index)}
                                                    style={{ marginTop: 40, color: 'red' }}
                                                    aria-label="upload picture" component="span">
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                                : null
                                        }
                                    </Grid>
                                }
                                <Grid item xs={12} alignItems="flex-start">
                                    <FormHelperText className={classes.helpText}>{observation.error ? observation.errorStr : ''}</FormHelperText>
                                </Grid>
                            </Grid>
                        );
                    })}
                </div>

                <Grid container spacing={3} alignItems="flex-start" style={{ marginTop: 20 }}>
                    <Button
                        color="default"
                        onClick={addObservation}
                        style={{ paddingLeft: 20, color: '#0049A3', fontSize: 18 }}
                        startIcon={<AddIcon />}>
                        Add Another Observation
                </Button>
                </Grid>
            </Grid>
        </React.Fragment >
    );
}

export default Observations;